import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui"; // import markdown from "@view/components-demo/markdown";

import { getGameType, addGamedetailing, updataGamedetailing, returnGamedetailing } from "@/api/dataAll/gameDtailss";
export default {
  name: "addMsgSharing",
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  // components:mavonEditor
  data: function data() {
    var _ref;

    return _ref = {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      form: {
        details: '',
        game: ''
      }
    }, _defineProperty(_ref, "id", ""), _defineProperty(_ref, "gameData", []), _defineProperty(_ref, "rules", {// game: [{ required: true, message: "游戏", trigger: "blur" }],
      // platform: [{ required: true, message: "平台", trigger: "blur" }],
      // parameter: [{ required: true, message: "参数", trigger: "blur" }],
    }), _defineProperty(_ref, "formLabelWidth", "80px"), _defineProperty(_ref, "toolbars", {
      bold: true,
      // 粗体
      italic: true,
      // 斜体
      header: true,
      // 标题
      underline: true,
      // 下划线
      strikethrough: true,
      // 中划线
      mark: true,
      // 标记
      superscript: true,
      // 上角标
      subscript: true,
      // 下角标
      quote: true,
      // 引用
      ol: true,
      // 有序列表
      ul: true,
      // 无序列表
      link: true,
      // 链接
      imagelink: true,
      // 图片链接
      code: true,
      // code
      table: true,
      // 表格
      fullscreen: true,
      // 全屏编辑
      readmodel: true,
      // 沉浸式阅读
      htmlcode: true,
      // 展示html源码
      help: true,
      // 帮助
      undo: true,
      // 上一步
      redo: true,
      // 下一步
      trash: true,
      // 清空
      save: true,
      // 保存（触发events中的save事件）
      navigation: true,
      // 导航目录
      alignleft: true,
      // 左对齐
      aligncenter: true,
      // 居中
      alignright: true,
      // 右对齐
      subfield: true,
      // 单双栏模式
      preview: true // 预览

    }), _ref;
  },
  created: function created() {
    var _this = this;

    this.searchMark = {};
    getGameType().then(function (res) {
      _this.gameData = res.data;
    });
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(id, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$returnGamedeta, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (num == 1) {
                  _this2.titleName = "新增游戏详情";
                  _this2.form = {};
                }

                _this2.id = id;

                if (!(id != "t")) {
                  _context.next = 18;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 18;
                  break;
                }

                _this2.titleName = "修改游戏详情";
                _this2.id = id;
                tid = {
                  id: id
                };
                _context.next = 10;
                return returnGamedetailing(tid);

              case 10:
                _yield$returnGamedeta = _context.sent;
                data = _yield$returnGamedeta.data;
                _this2.form.details = data.details;
                _this2.searchMark.details = data.details;
                _this2.form.game = data.game;
                _this2.searchMark.game = data.game;
                _this2.searchMark.id = data.id;

                _this2.$set(_this2.form, _this2.form.game, "");

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    classifychange: function classifychange(val) {
      this.searchMark.game = val;
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      if (this.titleName == "新增游戏详情") {
        this.searchMark.kind = 1;
        this.searchMark.details = this.form.details;
        addGamedetailing(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message); // this.$emit("refreshDataList");

            _this3.resetForm("ruleForm");
          } else {
            Message.warning(res.message);

            _this3.resetForm("ruleForm");
          }
        });
      }

      if (this.titleName == "修改游戏详情") {
        this.searchMark.details = this.form.details;
        updataGamedetailing(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message);

            _this3.$emit("refreshDataList");

            _this3.resetForm("ruleForm");
          } else {
            Message.warning(res.message);
          }
        });
      }
    },
    clearData: function clearData() {
      this.form = {};
      this.searchMark = {};
    }
  }
};